import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Recursively apply the `filter` function to the `navItems` contained in
 * `parentItem` and return a new nav item if applicable. (That is, if the filter
 * ends up having no effect, the same instance will be returned.)
 */
export function filterNavItems(parentItem, filter) {
  var wasFiltered = false;

  var filterAndSetFlag = function filterAndSetFlag() {
    var result = filter(...arguments);

    if (!result) {
      wasFiltered = true;
    }

    return result;
  };

  if (parentItem.navItems) {
    var newItems = parentItem.navItems // Pass an additional arg to the filter: the parent item.
    .filter(function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return filterAndSetFlag(...args, parentItem);
    }).map(navItem => filterNavItems(navItem, filterAndSetFlag));

    if (wasFiltered) {
      return _objectSpread(_objectSpread({}, parentItem), {}, {
        navItems: newItems
      });
    }
  }

  return parentItem;
}